export const MailIcon = ({className}) => {
  return (
    <svg
      width="27"
      height="28"
      viewBox="0 0 27 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M26.3325 9.51324L14.3325 1.10967C14.086 0.93692 13.7963 0.844727 13.5 0.844727C13.2037 0.844727 12.914 0.93692 12.6675 1.10967L0.667502 9.51324C0.461846 9.65738 0.293292 9.85267 0.176837 10.0818C0.0603816 10.3108 -0.000364805 10.5666 1.64818e-06 10.8263V24.4821C1.64818e-06 25.1786 0.263394 25.8466 0.732235 26.339C1.20108 26.8315 1.83696 27.1082 2.5 27.1082H24.5C25.163 27.1082 25.7989 26.8315 26.2678 26.339C26.7366 25.8466 27 25.1786 27 24.4821V10.8263C27.0004 10.5666 26.9396 10.3108 26.8232 10.0818C26.7067 9.85267 26.5382 9.65738 26.3325 9.51324ZM13.5 4.31616L22.8575 10.8696L15.2013 16.6038H11.7988L4.1425 10.8696L13.5 4.31616ZM3 23.9569V13.8844L10.4475 19.4623C10.7029 19.6536 11.0089 19.756 11.3225 19.7551H15.685C15.9986 19.756 16.3046 19.6536 16.56 19.4623L24 13.8844V23.9569H3Z"
        fill="currentColor" />
    </svg>

  );
};
